import { createApp, configureCompat } from 'vue';
import App from './App.vue';
import lgModal from './components/PageLogin';
import mdModal from './components/BaseUi/MessageModal/src';
import loading from './components/BaseUi/LoadingModal';
import textLoadingModal from './components/BaseUi/LoadingModalwithText';
import mobilePageHeadMenu from './components/BaseUi/MobilePageHeadMenu';
import signUpStep1 from './components/Step1Modal';
import router from './router';
import store from './store';
import http from './services';
import i18n from './i18n/index';
import fastclick from 'fastclick';
import axios from 'axios';
import qs from 'qs';
import '@/utils/rem';
import '@/assets/css/styles.css';
import msgModal from '@/components/BaseUi/MessageModal/src';
// import connectErrorImg from '@/assets/images/connectError.png';
import { decryptAES } from '@/utils';
import { LazyLoad } from '@/utils/directive';
import { compileMessages } from '@/utils/i18n-compiler';
import './utils/fs.js';

configureCompat({
  MODE: 3,
  GLOBAL_EXTEND: true,
  // GLOBAL_MOUNT: true,
  // INSTANCE_SET: true,
  // OPTIONS_BEFORE_DESTROY: true,
});

const app = createApp(App);

app.config.globalProperties.$http = http;
app.config.globalProperties.$loginModal = lgModal;
app.config.globalProperties.$messageModal = mdModal;
app.config.globalProperties.$loading = loading;
app.config.globalProperties.$mobilePageHeadMenu = mobilePageHeadMenu;
app.config.globalProperties.$signUpStep1 = signUpStep1;

fastclick.attach(document.body);

app.use(router);
app.use(store);
app.use(i18n);
app.use(LazyLoad, { default: '' });
// app.use(lgModal);
// app.use(mdModal);
// app.use(loading);
app.use(textLoadingModal);
// app.use(signUpStep1);

loading.show();
const serverUrl = process.env.VUE_APP_BASE_API;
const langPackServer = {
  'https://dp-oss.dragonpass.com/': 'dp-oss',
  'https://img.dragonpass.com.cn/': 'img',
};

let hasMounted = false;
const mountApp = () => {
  if (hasMounted) {
    return;
  }
  hasMounted = true;
  app.mount('#app');
};

const getLang = async () => {
  const lang = localStorage.getItem('lang') ?? 'en_US';
  localStorage.setItem('lang', lang);

  try {
    const res = await axios({
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        'X-Visa-Region': 'canada',
        unEncryptToken: true,
      },
      method: 'GET',
      url: `${serverUrl}/visa/latam/langeSetting/list/v2?lang=${lang}&device=web`,
    });

    const { state, list } = res.data;

    if (state === '11') {
      store.state.globalLangList = list || [];

      if (list && list.length > 0) {
        const enLangPath = list.find(item => item.param === 'en_US').path;
        let s = null;
        Object.keys(langPackServer).forEach(_ => {
          if (enLangPath.includes(_)) {
            s = {
              server: _,
              tag: langPackServer[_],
            };
          }
        });
        const enLang = enLangPath.split(s.server)[1];
        try {
          const enLangRes = await axios.get(`/packServer/${s.tag}/${enLang}`);
          // 使用 serverUrl 变量, 以兼容新环境, 并且去掉 serverUrl 中的/basic-api
          // const domain = serverUrl.replace('/basic-api', '');
          // const enLangRes = await axios.get(`${domain}/packServer/${s.tag}/${enLang}`);
          if (enLangRes) {
            i18n.global.mergeLocaleMessage('en_US', compileMessages(enLangRes.data.content));
            if (i18n.global.locale === 'en_US') loading.hide();
            mountApp();
            try {
              const user =
                sessionStorage.getItem('user') &&
                JSON.parse(decryptAES(sessionStorage.getItem('user')));
              const userId = user?.userId || '';
              const data = {
                lang,
                userId,
              };
              if (userId) {
                await axios({
                  headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'X-Visa-Region': 'canada',
                    unEncryptToken: true,
                  },
                  method: 'POST',
                  url: `${serverUrl}/visa/latam/langeSetting/change`,
                  data: qs.stringify(data),
                });
              }
            } catch (err) {
              console.error(err);
            }
            if (i18n.global.locale !== 'en_US') {
              const currentLangPath = list.find(item => item.param === i18n.global.locale).path;
              let s = null;
              Object.keys(langPackServer).forEach(_ => {
                if (currentLangPath.includes(_)) {
                  s = {
                    server: _,
                    tag: langPackServer[_],
                  };
                }
              });
              const currentLang = currentLangPath.split(s.server)[1];
              try {
                const currentLangRes = await axios.get(`/packServer/${s.tag}/${currentLang}`);
                // const domain = serverUrl.replace('/basic-api', '');
                // const currentLangRes = await axios.get(
                //   `${domain}/packServer/${s.tag}/${currentLang}`,
                // );
                if (currentLangRes) {
                  i18n.global.mergeLocaleMessage(
                    i18n.global.locale,
                    compileMessages(currentLangRes.data.content),
                  );
                  loading.hide();
                }
              } catch (err) {
                await askAgain(err);
              }
            }
          }
        } catch (err) {
          await askAgain(err);
        }
      }
    }
  } catch (err) {
    await askAgain(err);
  }
};
getLang();

let timer = null;
let count = 0;
const askAgain = err => {
  timer = setTimeout(() => {
    count += 1;
    if (count < 5) {
      getLang();
    } else {
      clearTimeout(timer);
      timer = null;
      console.error(err);
    }
  }, 5000);
};

window.addEventListener('offline', async () => {
  msgModal.show({
    image: true,
    sucImgSrc:
      'data:image/png;base64,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\n',
    title: 'no-internet-connection',
    i18nNeed: true,
    desc: 'check-internet',
    confirmBtn: 'ok',
    justHide: true,
  });
});
window.addEventListener('online', () => {
  msgModal.hide();
});

export default app;
